import { startLinkedApp } from './linkedAppSso';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import Mobile from './Mobile';
import { BrowserRouter as Router } from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
import ThemeProvider from './styles/theme';
import GlobalStyle from './styles/GlobalStyle';

// v2: PC/모바일 통합 — 반응형 디자인으로 처리 (Mobile.js 분기 제거)
if (window.location.href === 'https://www.antsnest.co.kr/') {
  window.location.replace('https://antsnest.co.kr/');
} else {
  startLinkedApp(() => {
ReactDOM.render(
    <ThemeProvider>
      <GlobalStyle />
      <Router>
        <App />
      </Router>
    </ThemeProvider>,
    document.getElementById('root')
  );
}, '/api/auth/sso-handoff');
}
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
